import { render, staticRenderFns } from "./GrowtradeLogin.vue?vue&type=template&id=4fe81b88&scoped=true&"
import script from "./GrowtradeLogin.vue?vue&type=script&lang=js&"
export * from "./GrowtradeLogin.vue?vue&type=script&lang=js&"
import style0 from "./GrowtradeLogin.vue?vue&type=style&index=0&id=4fe81b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe81b88",
  null
  
)

export default component.exports